<!-- <div>
    <div class="header-container">
        <h2>Task</h2>
        <mat-icon *ngIf = "deviceXs || deviceSm || deviceMd">
            menu
        </mat-icon>
    </div>
    <div class="horizontal-navigation-container">
        <div class="horizontal-left-container">
            <ul class="horizontal-navigation-list">
                <li class="list-item" routerLink="/upcomingMeetings" routerLinkActive="active"><h3  [ngStyle.xs] = "{
                    'font-size.px' : 10
                 }">Assigned to</h3></li>
                <li class="list-item" routerLink="/pastMeetings" routerLinkActive="active"><h3  [ngStyle.xs] = "{
                    'font-size.px' : 10
                 }">Completed</h3></li>
                <li class="list-item" routerLink="/pastMeetings" routerLinkActive="active"><h3  [ngStyle.xs] = "{
                    'font-size.px' : 10
                 }">All(109)</h3></li>
            </ul>
        </div>
        <div class="horizontal-right-container">
            <h3 style="align-self: center;margin-right: 10px;" [ngStyle.xs] = "{
                'padding-top.px' : 5,
                'padding-right.px' : 10,
                'padding-left.px' : 45
             }">Group by</h3>
            <mat-form-field fxFlex.xs = "50px"> 
                <mat-label>Project Type</mat-label>
                <mat-select multiple>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <mat-drawer-container class="example-container" [ngStyle.xs] = "{
        'margin.px' : 0,
        'margin-top.px' : 10
     }">
        <mat-drawer class="drawer" mode="side" opened = "true" *ngIf = "deviceLg || deviceXl">
            <app-task-list-tree></app-task-list-tree>
        </mat-drawer>
        <mat-drawer opened = "true" class="drawer" mode = "over" fxFlex.xs = "180px" *ngIf = "deviceXs||deviceSm||deviceMd">
            <app-tree></app-tree>
        </mat-drawer>
        <mat-drawer-content>
            <app-task-list-item [deviceXs] = "deviceXs" [deviceLg] = "deviceLg" [deviceMd] = "deviceMd" [deviceXl] = "deviceXl"></app-task-list-item>
        </mat-drawer-content>
    </mat-drawer-container>
    
</div> -->
<div class="bread-crumb-container">
    <h2 class="margin-0">Task</h2>
</div>
<div class="wrapper">    
    <app-task-search-grid></app-task-search-grid>
</div>
<!-- <app-coming-soon-page></app-coming-soon-page> -->
